import { combineReducers } from 'redux';

import loggedReducer from './UserInfo/isLogged';
import chartPropertiesState from './ChartPoperties/ChartProperties';
import PlayBookReducer from './PlayBook/PlayBook';
import chartControlsReducer from './ChartPoperties/ChartControls';
import tabStateReducer from './TabTile/TabState';
import tileStateReducer from './TabTile/TileState';
import tabTilePropsReducer from './TabTile/TabTileProps';
import FlatFileReducer from './FlatFile/FlatFileState';
import DownloadPageSettingReducer from './PageSettings/DownloadPageSettingState';
import chartFilterGroupReducer from './ChartFilterGroup/ChartFilterGroupState';
import DynamicMeasureReducer from './DynamicMeasures/DynamicMeasureState';
import dashBoardFilterGroupReducer from './DashBoardFilterGroup/DashBoardFilterGroupState';
import CalculationReducer from './Calculations/Calculations';
import permissionReducer from './Permissions/permission.reducer';
import ParameterReducer from './Parameters/Parameters';
import DataSetReducerV2 from './_Dataset/dataset.reducer';

const allReducers = combineReducers({
  isLogged: loggedReducer,
  permissions: permissionReducer,

  tabState: tabStateReducer,
  tileState: tileStateReducer,
  tabTileProps: tabTilePropsReducer,

  chartProperties: chartPropertiesState,
  chartControls: chartControlsReducer,
  playBookState: PlayBookReducer,
  flatFileState: FlatFileReducer,
  pageSettings: DownloadPageSettingReducer,
  chartFilterGroup: chartFilterGroupReducer,
  dynamicMeasuresState: DynamicMeasureReducer,
  dashBoardFilterGroup: dashBoardFilterGroupReducer,

  calculations: CalculationReducer,

  parameters: ParameterReducer,
  dataset: DataSetReducerV2,
});

export type RootState = ReturnType<typeof allReducers>;

export default allReducers;
